import script from "./dailyTreasureView.vue?vue&type=script&setup=true&lang=ts"
export * from "./dailyTreasureView.vue?vue&type=script&setup=true&lang=ts"

import "./dailyTreasureView.vue?vue&type=style&index=0&id=28883910&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28883910"]])

export default __exports__